import { EmailInviteMode } from "@pages/candidate/list/DVTJCUVEmailInviteModal";
import {
    DVTJCUVAcquireCddEmailFUTabIds,
    DVTJCUVAcquireCddParentTabIds,
    DVTJCUVAcquireCddSendEmailTabIds
} from "@pages/dvtjcuv/common/AcquireCddTabs";
import {
    DVTJCUVConnectCddEmpParentTabs,
    DVTJCUVConnectCddFUReceiverSendEmailTabs,
    DVTJCUVConnectCddFUReceiverTabs,
    DVTJCUVConnectCddSendEmailReceiverUpdateInfoTabs,
    DVTJCUVConnectCddSendEmailTabs
} from "@pages/dvtjcuv/common/ConnectCddEmpTabs";
import {
    DVTJCUVSearchCddJobParentTabs,
    DVTJCUVSearchCddJobSendEmailBriefUVTabs
} from "@pages/dvtjcuv/common/SearchCddJobTabs";
import {
    DVTJCUVWorkWithRecSendEmailInviteJobSendEmailFUTabs,
    DVTJCUVWorkWithRecSendEmailInviteJobSendEmailTabs,
    DVTJCUVWorkWithRecSendEmailInviteJobTabs
} from '@pages/dvtjcuv/common/WorkWithRecTabs';


import React, { useEffect, useState } from 'react';

const DVTJCUVCandidateActions = (props) => {
    const {
        parentTab,
        subTab,
        onDraftPreview,
        onExportExcel,
        // onEmailFU,
        onSendEmailDVTJCUV,
        onSendBriefEmailDVTJCUV,
        onInputEmailInputDVTJCUV,
        onShowDVTJCUVEmailInviteTemp,
        onStartCheckingRunDVTJCUVConditions,
        onClickMoveCandidatesToTab,
        onRemoveSendMailThisTime,
        onRemoveCandidateOutTabs,
        onEmailBD
    } = props;
    const [parentOfTab, setParentOfTab] = useState({});
    const [currentTab, setCurrentTab] = useState({});
    useEffect(() => {
        setParentOfTab(parentTab);
        setCurrentTab(subTab);
        console.log('DVTJCUVCandidateActions:' + JSON.stringify(parentTab));
        console.log('DVTJCUVCandidateActions:' + JSON.stringify(subTab));
    }, [parentTab, subTab]);
    return (
        <>
            <div className="btn-group">
                <button type="button" className="btn btn-default">
                    Actions
                </button>
                <button
                    type="button"
                    className="btn btn-default dropdown-toggle dropdown-icon"
                    data-toggle="dropdown"
                >
                    <span className="sr-only">Toggle Dropdown</span>
                </button>
                <div className="dropdown-menu" role="menu">
                    {parentOfTab.id === DVTJCUVAcquireCddParentTabIds.PRE_EMAIL_TAB && (
                        <>
                            {currentTab.id === DVTJCUVAcquireCddSendEmailTabIds.APPROVE_DRAFT && (
                                <button
                                    type={'button'}
                                    onClick={() => {
                                    }}
                                    rel="noopener noreferrer"
                                    className={'dropdown-item'}
                                >
                                    Target
                                </button>
                            )}
                            <button
                                type={'button'}
                                onClick={() => onSendEmailDVTJCUV({ invite_mode: EmailInviteMode.INVITE_EMAIL })}
                                rel="noopener noreferrer"
                                className={'dropdown-item'}
                            >
                                Gửi email mời DVTJCUV
                            </button>
                        </>
                    )}
                    {parentOfTab.id === DVTJCUVAcquireCddParentTabIds.EMAIL_TAB &&
                        currentTab.id ===
                        DVTJCUVAcquireCddSendEmailTabIds.APPROVE_DRAFT && (
                            <>
                                <button
                                    type={'button'}
                                    onClick={() => onDraftPreview()}
                                    rel="noopener noreferrer"
                                    className={'dropdown-item'}
                                >
                                    Draft Preview
                                </button>
                                <button
                                    type={'button'}
                                    onClick={() => onSendEmailDVTJCUV({ invite_mode: EmailInviteMode.INVITE_EMAIL })}
                                    rel="noopener noreferrer"
                                    className={'dropdown-item'}
                                >
                                    Gửi email mời DVTJCUV
                                </button>
                                <button
                                    type={'button'}
                                    onClick={() => onRemoveSendMailThisTime()}
                                    rel="noopener noreferrer"
                                    className={'dropdown-item'}
                                >
                                    Loại Person khỏi list gửi email lần này
                                </button>
                            </>
                        )}

                    {parentOfTab.id === DVTJCUVAcquireCddParentTabIds.EMAIL_TAB &&
                        (currentTab.id ===
                            DVTJCUVAcquireCddSendEmailTabIds.NOT_PERMISSION_EMAIL ||
                            currentTab.id ===
                            DVTJCUVAcquireCddSendEmailTabIds.NEED_CHECKING ||
                            currentTab.id ===
                            DVTJCUVAcquireCddSendEmailTabIds.NEED_INPUT_INFO ||
                            currentTab.id ===
                            DVTJCUVAcquireCddSendEmailTabIds.SEND_WHEN_UNLIMITED) && (
                            <>
                                {/*<button*/}
                                {/*    type={'button'}*/}
                                {/*    onClick={() => onEmailBD()}*/}
                                {/*    rel="noopener noreferrer"*/}
                                {/*    className={'dropdown-item'}*/}
                                {/*>*/}
                                {/*    email BD*/}
                                {/*</button>*/}

                                <button
                                    type={'button'}
                                    onClick={() => onSendEmailDVTJCUV({ invite_mode: EmailInviteMode.INVITE_EMAIL })}
                                    rel="noopener noreferrer"
                                    className={'dropdown-item'}
                                >
                                    Gửi email mời DVTJCUV
                                </button>

                                {(currentTab.id === DVTJCUVAcquireCddSendEmailTabIds.NEED_CHECKING) &&
                                    <button
                                        type={'button'}
                                        onClick={() => onStartCheckingRunDVTJCUVConditions(
                                            {
                                                ignore_checking_dk_1: false,
                                                ignore_checking_dk_2: true,
                                                invite_mode: EmailInviteMode.INVITE_EMAIL
                                            }
                                        )}
                                        rel="noopener noreferrer"
                                        className={'dropdown-item'}
                                    >
                                        Bỏ qua lỗi ĐK 2
                                    </button>
                                }
                            </>
                        )}
                    {parentOfTab.id === DVTJCUVSearchCddJobParentTabs.SEND_EMAIL_BRIEF_UV_TAB.id && (
                        <>
                            {/*<button*/}
                            {/*    type={'button'}*/}
                            {/*    onClick={() => onEmailBD()}*/}
                            {/*    rel="noopener noreferrer"*/}
                            {/*    className={'dropdown-item'}*/}
                            {/*>*/}
                            {/*    email BD*/}
                            {/*</button>*/}

                            <button
                                type={'button'}
                                onClick={() => onSendBriefEmailDVTJCUV({ invite_mode: EmailInviteMode.INVITE_BRIEF_EMAIL })}
                                rel="noopener noreferrer"
                                className={'dropdown-item'}
                            >
                                Email Brief UV
                            </button>

                            {(currentTab.id === DVTJCUVSearchCddJobSendEmailBriefUVTabs.NEED_CHECKING_TAB.id) &&
                                <button
                                    type={'button'}
                                    onClick={() => onSendBriefEmailDVTJCUV(
                                        {
                                            ignore_checking_dk_1: false,
                                            ignore_checking_dk_2: true,
                                            invite_mode: currentTab.id === DVTJCUVSearchCddJobSendEmailBriefUVTabs.NEED_CHECKING_TAB.id ? EmailInviteMode.INVITE_BRIEF_EMAIL : EmailInviteMode.INVITE_EMAIL_DN_UPDATE_INFO
                                        }
                                    )}
                                    rel="noopener noreferrer"
                                    className={'dropdown-item'}
                                >
                                    Bỏ qua lỗi ĐK 2
                                </button>
                            }
                        </>
                    )}
                    {(parentOfTab.id === DVTJCUVConnectCddEmpParentTabs.SEND_EMAIL_RECEIVER_UPDATE_INFO_TAB.id
                        || parentOfTab.id === DVTJCUVConnectCddSendEmailReceiverUpdateInfoTabs.SEND_EMAIL_TAB.id
                    ) && (
                            <>
                                <button
                                    type={'button'}
                                    onClick={() => onSendBriefEmailDVTJCUV({ invite_mode: EmailInviteMode.INVITE_EMAIL_DN_UPDATE_INFO })}
                                    rel="noopener noreferrer"
                                    className={'dropdown-item'}
                                >
                                    Gửi Email đn update info
                                </button>
                                {currentTab.id === DVTJCUVConnectCddFUReceiverSendEmailTabs.NEED_CHECKING_TAB.id &&
                                    <button
                                        type={'button'}
                                        onClick={() => onSendBriefEmailDVTJCUV(
                                            {
                                                ignore_checking_dk_1: false,
                                                ignore_checking_dk_2: true,
                                                invite_mode: EmailInviteMode.INVITE_EMAIL_DN_UPDATE_INFO
                                            }
                                        )}
                                        rel="noopener noreferrer"
                                        className={'dropdown-item'}
                                    >
                                        Bỏ qua lỗi ĐK 2
                                    </button>
                                }
                            </>
                        )}

                    {parentOfTab.id === DVTJCUVWorkWithRecSendEmailInviteJobTabs.SEND_EMAIL_INVITE_JOB_TAB.id && (
                        <>
                            <button
                                type={'button'}
                                onClick={() => onSendEmailDVTJCUV({ invite_mode: EmailInviteMode.INVITE_EMAIL_INVITE_SEND_JOB })}
                                rel="noopener noreferrer"
                                className={'dropdown-item'}
                            >
                                Email mời gửi job
                            </button>
                            {currentTab.id === DVTJCUVWorkWithRecSendEmailInviteJobSendEmailTabs.NEED_CHECKING_TAB.id &&
                                <button
                                    type={'button'}
                                    onClick={() => onSendEmailDVTJCUV(
                                        {
                                            ignore_checking_dk_1: false,
                                            ignore_checking_dk_2: true,
                                            invite_mode: EmailInviteMode.INVITE_EMAIL_INVITE_SEND_JOB
                                        }
                                    )}
                                    rel="noopener noreferrer"
                                    className={'dropdown-item'}
                                >
                                    Bỏ qua lỗi ĐK 2
                                </button>
                            }
                        </>
                    )}

                    {parentOfTab.id === DVTJCUVWorkWithRecSendEmailInviteJobTabs.SEND_EMAIL_INVITE_JOB_FU_TAB.id && (
                        <>
                            <button
                                type={'button'}
                                onClick={() => onSendEmailDVTJCUV({ invite_mode: EmailInviteMode.INVITE_EMAIL_INVITE_SEND_JOB_FU })}
                                rel="noopener noreferrer"
                                className={'dropdown-item'}
                            >
                                Email mời gửi job (FU)
                            </button>
                            {currentTab.id === DVTJCUVWorkWithRecSendEmailInviteJobSendEmailFUTabs.NEED_CHECKING_TAB.id &&
                                <button
                                    type={'button'}
                                    onClick={() => onSendEmailDVTJCUV(
                                        {
                                            ignore_checking_dk_1: false,
                                            ignore_checking_dk_2: true,
                                            invite_mode: EmailInviteMode.INVITE_EMAIL_INVITE_SEND_JOB_FU
                                        }
                                    )}
                                    rel="noopener noreferrer"
                                    className={'dropdown-item'}
                                >
                                    Bỏ qua lỗi ĐK 2
                                </button>
                            }
                        </>
                    )}

                    {parentOfTab.id === DVTJCUVSearchCddJobParentTabs.SEND_EMAIL_BRIEF_UV_TAB.id
                        && currentTab.id === DVTJCUVSearchCddJobSendEmailBriefUVTabs.EXPORTED_WAITING_SEND_EMAIL_BRIEF_UV_TAB.id && (
                            <>
                                <button
                                    type={'button'}
                                    onClick={() => onInputEmailInputDVTJCUV(EmailInviteMode.INVITE_BRIEF_EMAIL)}
                                    rel="noopener noreferrer"
                                    className={'dropdown-item'}
                                >
                                    Nhập liệu Email gửi Brief
                                </button>
                            </>
                        )}
                    {
                        parentOfTab.id === DVTJCUVConnectCddSendEmailReceiverUpdateInfoTabs.SEND_EMAIL_TAB.id
                        && currentTab.id === DVTJCUVConnectCddSendEmailTabs.EXPORTED_WAITING_SEND_EMAIL_RECEIVER_UPDATE_INFO_TAB.id && (
                            <>
                                <button
                                    type={'button'}
                                    onClick={() => onInputEmailInputDVTJCUV(EmailInviteMode.INVITE_EMAIL_DN_UPDATE_INFO)}
                                    rel="noopener noreferrer"
                                    className={'dropdown-item'}
                                >
                                    Nhập liệu Email đn update info
                                </button>
                            </>
                        )}
                    {
                        parentOfTab.id === DVTJCUVWorkWithRecSendEmailInviteJobTabs.SEND_EMAIL_INVITE_JOB_TAB.id
                        && currentTab.id === DVTJCUVWorkWithRecSendEmailInviteJobSendEmailTabs.EXPORTED_WAITING_SEND_EMAIL_TAB.id && (
                            <>
                                <button
                                    type={'button'}
                                    onClick={() => onInputEmailInputDVTJCUV(EmailInviteMode.INVITE_EMAIL_INVITE_SEND_JOB)}
                                    rel="noopener noreferrer"
                                    className={'dropdown-item'}
                                >
                                    Nhập liệu Email mời gửi job
                                </button>
                            </>
                        )}
                    {
                        parentOfTab.id === DVTJCUVWorkWithRecSendEmailInviteJobTabs.SEND_EMAIL_INVITE_JOB_FU_TAB.id
                        && currentTab.id === DVTJCUVWorkWithRecSendEmailInviteJobSendEmailFUTabs.EXPORTED_WAITING_SEND_EMAIL_TAB.id && (
                            <>
                                <button
                                    type={'button'}
                                    onClick={() => onInputEmailInputDVTJCUV(EmailInviteMode.INVITE_EMAIL_INVITE_SEND_JOB_FU)}
                                    rel="noopener noreferrer"
                                    className={'dropdown-item'}
                                >
                                    Nhập liệu Email mời gửi job (FU)
                                </button>
                            </>
                        )}
                    {parentOfTab.id === DVTJCUVConnectCddFUReceiverTabs.SEND_EMAIL_TAB.id
                        && currentTab.id === DVTJCUVConnectCddFUReceiverSendEmailTabs.EXPORTED_WAITING_SEND_EMAIL_TAB.id && (
                            <>
                                <button
                                    type={'button'}
                                    onClick={() => onInputEmailInputDVTJCUV(EmailInviteMode.INVITE_EMAIL_FU_REC)}
                                    rel="noopener noreferrer"
                                    className={'dropdown-item'}
                                >
                                    Nhập liệu Email FU Receiver
                                </button>
                            </>
                        )}
                    {parentOfTab.id === DVTJCUVAcquireCddParentTabIds.EMAIL_TAB
                        && currentTab.id === DVTJCUVAcquireCddSendEmailTabIds.EXPORTED_WAITING_SEND_EMAIL && (
                            <>
                                <button
                                    type={'button'}
                                    onClick={() => onInputEmailInputDVTJCUV(EmailInviteMode.INVITE_EMAIL)}
                                    rel="noopener noreferrer"
                                    className={'dropdown-item'}
                                >
                                    Nhập liệu Email mời DVTJCUV
                                </button>
                                <button
                                    type={'button'}
                                    onClick={() => {
                                    }}
                                    rel="noopener noreferrer"
                                    className={'dropdown-item'}
                                >
                                    Export lại
                                </button>
                                <button
                                    type={'button'}
                                    onClick={() => {
                                        onClickMoveCandidatesToTab(
                                            DVTJCUVAcquireCddSendEmailTabIds.EXPORTED_WAITING_SEND_EMAIL,
                                            DVTJCUVAcquireCddSendEmailTabIds.APPROVE_DRAFT)
                                    }}
                                    rel="noopener noreferrer"
                                    className={'dropdown-item'}
                                >
                                    Cut Paste back lại tab 2.1
                                </button>
                                {/*<button*/}
                                {/*    type={'button'}*/}
                                {/*    onClick={() => {*/}
                                {/*    }}*/}
                                {/*    rel="noopener noreferrer"*/}
                                {/*    className={'dropdown-item'}*/}
                                {/*>*/}
                                {/*    Xóa UV khỏi tab 1,2*/}
                                {/*</button>*/}
                            </>
                        )}
                    <>

                        {parentOfTab.id === DVTJCUVAcquireCddParentTabIds.FU_EMAIL_TAB &&
                            <>
                                <button
                                    type={'button'}
                                    onClick={() => onSendEmailDVTJCUV({ invite_mode: EmailInviteMode.INVITE_EMAIL_FU })}
                                    rel="noopener noreferrer"
                                    className={'dropdown-item'}
                                >
                                    Email FU DVTJCUV
                                </button>
                                <button
                                    type={'button'}
                                    onClick={() => onSendEmailDVTJCUV({
                                        invite_mode: EmailInviteMode.INVITE_EMAIL_FU,
                                        ignore_checking_dk_1: false,
                                        ignore_checking_dk_2: true
                                    })}
                                    rel="noopener noreferrer"
                                    className={'dropdown-item'}
                                >
                                    Bỏ qua lỗi ĐK 2
                                </button>
                            </>
                        }
                        {parentOfTab.id === DVTJCUVAcquireCddParentTabIds.FU_EMAIL_TAB
                            && currentTab.id === DVTJCUVAcquireCddEmailFUTabIds.EXPORTED_WAITING_SEND_EMAIL && (
                                <>
                                    <button
                                        type={'button'}
                                        onClick={() => onInputEmailInputDVTJCUV(EmailInviteMode.INVITE_EMAIL_FU)}
                                        rel="noopener noreferrer"
                                        className={'dropdown-item'}
                                    >
                                        Nhập liệu Email FU
                                    </button>
                                    <button
                                        type={'button'}
                                        onClick={() => {
                                            onClickMoveCandidatesToTab(
                                                DVTJCUVAcquireCddEmailFUTabIds.EXPORTED_WAITING_SEND_EMAIL,
                                                DVTJCUVAcquireCddEmailFUTabIds.APPROVE_DRAFT)
                                        }}
                                        rel="noopener noreferrer"
                                        className={'dropdown-item'}
                                    >
                                        Cut Paste back lại tab 3.1
                                    </button>
                                </>
                            )}
                        {parentTab?.id !== DVTJCUVConnectCddEmpParentTabs.FU_RECEIVERS_TAB.id &&
                            <>
                                <button
                                    type={'button'}
                                    onClick={() => onExportExcel()}
                                    rel="noopener noreferrer"
                                    className={'dropdown-item'}
                                >
                                    Export Excel
                                </button>
                                <button
                                    type={'button'}
                                    onClick={() => onRemoveCandidateOutTabs()}
                                    rel="noopener noreferrer"
                                    className={'dropdown-item'}
                                >
                                    Xóa Person khỏi các tab
                                </button>
                                {/*<button*/}
                                {/*    type={'button'}*/}
                                {/*    onClick={() => removeCandidateOutTabs()}*/}
                                {/*    rel="noopener noreferrer"*/}
                                {/*    className={'dropdown-item'}*/}
                                {/*>*/}
                                {/*    Xóa Person khỏi tab 1,2*/}
                                {/*</button>*/}
                            </>
                        }

                        {(parentTab?.id === DVTJCUVConnectCddEmpParentTabs.FU_RECEIVERS_TAB.id
                            || parentTab?.id === DVTJCUVConnectCddFUReceiverTabs.SEND_EMAIL_TAB.id) &&
                            <>
                                <button
                                    type={'button'}
                                    onClick={() => onSendBriefEmailDVTJCUV({ invite_mode: EmailInviteMode.INVITE_EMAIL_FU_REC })}
                                    rel="noopener noreferrer"
                                    className={'dropdown-item'}
                                >
                                    Gửi Email FU Rec
                                </button>
                                {currentTab.id === DVTJCUVConnectCddSendEmailTabs.NEED_CHECKING_TAB.id &&
                                    <button
                                        type={'button'}
                                        onClick={() => onSendBriefEmailDVTJCUV({
                                            invite_mode: EmailInviteMode.INVITE_EMAIL_FU_REC,
                                            ignore_checking_dk_1: false,
                                            ignore_checking_dk_2: true
                                        })}
                                        rel="noopener noreferrer"
                                        className={'dropdown-item'}
                                    >
                                        Bỏ qua lỗi ĐK 2
                                    </button>
                                }
                            </>
                        }
                    </>
                </div>
            </div>
        </>
    )
        ;
};

export default DVTJCUVCandidateActions;
